import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ToggleField } from '../../../store/models/field-models';
import { ValidationRuleType } from '../../../store/models/validator-models';

@Component({
    selector: 'app-toggle-field',
    templateUrl: './toggle-field.component.html',
    styleUrls: ['./toggle-field.component.scss'],
})
export class ToggleFieldComponent {
    @Input() field: ToggleField;
    @Input() control: FormControl;
    @Input() fieldId: string;

    constructor(private store: Store, private translate: TranslateService) {}

    get isVisible(): boolean {
        return this.field?.visible !== false;
    }

    get isRequired(): boolean {
        return this.field?.validators?.some((v) => v.type === ValidationRuleType.Required) || false;
    }

    toggleChange(event: MatSlideToggleChange): void {
        if (this.field.events?.onChange) {
            this.field.events.onChange(event.checked).forEach((action) => this.store.dispatch(action));
        }
    }
}
